import { Pipe, PipeTransform } from '@angular/core';

export const adjectives = [
  'Schöne',
  'Kluge',
  'Mutige',
  'Sanfte',
  'Starke',
  'Freundliche',
  'Lustige',
  'Ernste',
  'Liebenswerte',
  'Geduldige',
  'Fleißige',
  'Harmonische',
  'Kreative',
  'Besonnene',
  'Sensible',
  'Zufriedene',
  'Wagemutige',
  'Achtsame',
  'Aktuelle',
  'Bedeutende',
  'Begeisterte',
  'Beliebte',
  'Berühmte',
  'Blühende',
  'Clevere',
  'Coole',
  'Dankbare',
  'Dynamische',
  'Elegante',
  'Entspannte',
  'Erfinderische',
  'Belebte',
  'Furchtlose',
  'Geniale',
  'Glückliche',
  'Funkelnde',
  'Glitzernde',
  'Humorvolle',
  'Sortierte',
  'Kräftige',
  'Lebendige',
  'Lebhafte',
  'Leuchtende',
  'Kurze',
  'Ganze',
  'Magische',
  'Mächtige',
  'Moderne',
  'Natürliche',
  'Nützliche',
  'Heitere',
  'Ehrliche',
  'Positive',
  'Respektvolle',
  'Ruhige',
  'Friedliche',
  'Schnelle',
  'Sichere',
  'Wache',
  'Tolle',
  'Traumhafte',
  'Verträumte',
  'Witzige',
  'Wunderbare',
  'Reiselustige',
  'Aufmerksame',
  'Anmutige',
  'Bezaubernde',
  'Bescheidene',
  'Anziehende',
  'Charmante',
  'Besorgte',
  'Denkende',
  'Bestimmte',
  'Einfühlsame',
  'Neugierige',
  'Erstaunliche',
  'Fabelhafte',
  'Geistreiche',
  'Attraktive',
  'Fesselnde',
  'Fleißige',
  'Flotte',
  'Fröhliche',
  'Fähige',
  'Rätselhafte',
  'Geschickte',
  'Glorreiche',
  'Großartige',
  'Heldenhafte',
  'Herzliche',
  'Hilfsbereite',
  'Ideenreiche',
  'Motivierende',
  'Jubelnde',
  'Eifrige',
  'Komische',
  'Königliche',
  'Kostbare',
  'Kühne',
  'Passionierte',
  'Liebevolle',
  'Lichtvolle',
  'Erhabene',
  'Mystische',
  'Neugierige',
  'Niedliche',
  'Originelle',
  'Prachtvolle',
  'Schlaue',
  'Sonnige',
  'Stolze',
  'Tapfere',
  'Gelbe',
];

export const nouns = [
  'Ärztin',
  'Sonne',
  'Wiese',
  'Straße',
  'Schülerin',
  'Katze',
  'Eiche',
  'Tasse',
  'Lampe',
  'Gitarre',
  'Zeitung',
  'Schokolade',
  'Schule',
  'Bank',
  'Küche',
  'Brücke',
  'Entdeckerin',
  'Amazone',
  'Bäckerin',
  'Blume',
  'Schwester',
  'Denkerin',
  'Diva',
  'Großmutter',
  'Erzählerin',
  'Fee',
  'Tochter',
  'Freundin',
  'Gärtnerin',
  'Genießerin',
  'Partnerin',
  'Hüterin',
  'Jägerin',
  'Nachbarin',
  'Königin',
  'Künstlerin',
  'Löwin',
  'Magierin',
  'Matrosin',
  'Mutter',
  'Pionierin',
  'Piratin',
  'Prinzessin',
  'Rebellin',
  'Retterin',
  'Aufständische',
  'Ritterin',
  'Sängerin',
  'Autorin',
  'Schützin',
  'Seherin',
  'Spürnase',
  'Sportlerin',
  'Strategin',
  'Tänzerin',
  'Träumerin',
  'Beschützerin',
  'Vorreiterin',
  'Wächterin',
  'Chefin',
  'Zauberin',
  'Zielstrebige',
  'Vermittlerin',
  'Wolken',
  'Alchemistin',
  'Archäologin',
  'Athletin',
  'Ballerina',
  'Bauherrin',
  'Diplomatin',
  'Chemikerin',
  'Detektivin',
  'Dirigentin',
  'Kämpferin',
  'Dichterin',
  'Doktorin',
  'Freiwillige',
  'Dame',
  'Erbin',
  'Erforscherin',
  'Erfinderin',
  'Expertin',
  'Fahrerin',
  'Falknerin',
  'Begleiterin',
  'Forscherin',
  'Frau',
  'Führerin',
  'Gelehrte',
  'Gentlewoman',
  'Gouvernante',
  'Händlerin',
  'Heilerin',
  'Heldin',
  'Konkurrentin',
  'Visionärin',
  'Historikerin',
  'Rednerin',
  'Jongleurin',
  'Journalistin',
  'Kapitänen',
  'Kauffrau',
  'Köchin',
  'Kommandantin',
  'Ingenieurin',
  'Kreative',
  'Kritikerin',
  'Kriegerin',
  'Akrobatin',
  'Malerin',
  'Lehrerin',
];

async function hashString(message: string): Promise<ArrayBuffer> {
  const msgBuffer = new TextEncoder().encode(message);
  return await crypto.subtle.digest('SHA-256', msgBuffer);
}

export async function getSeededNickname(value: string): Promise<string> {
  const hash = await hashString(value);
  const hexDigest = Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  // Get indices from first hash chars. Modulo them to not overshoot the array length.
  const adjectiveIndex =
    parseInt(hexDigest.charAt(0) + hexDigest.charAt(1) + hexDigest.charAt(2), 16) % adjectives.length;
  const nounIndex = parseInt(hexDigest.charAt(3) + hexDigest.charAt(4) + hexDigest.charAt(5), 16) % nouns.length;

  // Not using the number for now. (Stefan 2024-09) If this is long gone, we can delete it.
  // const number = parseInt(hexDigest.charAt(2), 16);
  // const nickname = `${adjectives[adjectiveIndex]}${nouns[nounIndex]}${number}`;

  return `${adjectives[adjectiveIndex]}${nouns[nounIndex]}`;
}

/*
 * An angular pipe that
 * - takes a string as an input
 * - creates a hash digest of the string with crypto.subtle
 * - then creates a nickname in the form of AdjectiveNounNumber,
 *   by using the first three characters of the created hex digest
 *   to choose an adjective, a noun, and a number from the given arrays
 */
@Pipe({
  name: 'badwordsNickname',
  standalone: true,
})
export class BadwordsNicknamePipe implements PipeTransform {
  transform = getSeededNickname;
}
